import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import 'bootstrap/dist/css/bootstrap.min.css';
import Router from './Router';
import ScrollToTop from './ScrollToTop';
import GlobalStyles from './globalStyles';

const App = () => (
  <BrowserRouter>
    <ScrollToTop>
      <ThemeProvider
        theme={{
          mode: 'light',
          direction: 'ltr',
          shadow: 'on',
          border: 'on',
        }}
      >
        <GlobalStyles />
        <Router />
      </ThemeProvider>
    </ScrollToTop>
  </BrowserRouter>
);

export default App;
